var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSymbol(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "174px",
    height: "194px",
    viewBox: "0 0 174 194",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group Copy 4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy-4",
    transform: "translate(6.652174, 7.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.0978261,79.75 C28.0978261,108.606878 51.4909479,132 80.3478261,132 C109.204704,132 132.597826,108.606878 132.597826,79.75",
    id: "Path",
    stroke: "#0F011F",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.3478261,160.695652 C124.722705,160.695652 160.695652,124.722705 160.695652,80.3478261 C160.695652,35.9729471 124.722705,0 80.3478261,0 C35.9729471,0 0,35.9729471 0,80.3478261 C0,91.310142 0,123.1942 0,176 L30.6086957,160.695652 C54.2390072,160.695652 70.8187174,160.695652 80.3478261,160.695652 Z",
    id: "Oval-Copy-2",
    stroke: "#0E001E",
    strokeWidth: 13
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbol);
export default __webpack_public_path__ + "static/media/symbol.5446ba5fc79335334ad4e79831cc9207.svg";
export { ForwardRef as ReactComponent };